const STANDARD_PHONE_LENGTH = 10;

class PhoneNumber {
  countryCode = '';
  areaCode = '';
  prefix = '';
  lineNumber = '';

  static fromString(phoneNumber: string): PhoneNumber {
    const phone = new PhoneNumber();

    if (!phoneNumber) {
      return phone;
    }

    const input = phoneNumber.replace(/\D/g, '');

    // Because country codes are optional, we need to see if a country code was provided.
    // Then offset the other parts of the phone number accordingly.
    const countryCodeOffset = input.length > STANDARD_PHONE_LENGTH ? input.length - STANDARD_PHONE_LENGTH : 0;
    phone.areaCode = input.slice(countryCodeOffset, 3 + countryCodeOffset);
    phone.prefix = input.slice(3 + countryCodeOffset, 6 + countryCodeOffset);
    phone.lineNumber = input.slice(6 + countryCodeOffset, 10 + countryCodeOffset);

    if (input.length > 10) {
      phone.countryCode = input.slice(0, input.length - STANDARD_PHONE_LENGTH);
    }

    return phone;
  }

  isValid(): boolean {
    return (
      this.countryCode.length <= 3 && // Country code is optional
      this.areaCode.length === 3 &&
      this.prefix.length === 3 &&
      this.lineNumber.length === 4
    );
  }

  toString(): string {
    if (this.isValid()) {
      const countryCodeFormat = this.countryCode ? `+${this.countryCode} ` : '';
      const areaCodeFormat = this.areaCode.length ? `(${this.areaCode}${this.areaCode.length === 3 ? ') ' : ''}` : '';
      const prefixFormat = this.prefix ? `${this.prefix}${this.prefix.length === 3 ? '-' : ''}` : '';
      return `${countryCodeFormat}${areaCodeFormat}${prefixFormat}${this.lineNumber}`;
    } else {
      return `${this.countryCode}${this.areaCode}${this.prefix}${this.lineNumber}`;
    }
  }
}

export default PhoneNumber;
